import { render, staticRenderFns } from "./AttachOtherDocument.vue?vue&type=template&id=a2e25636&"
import script from "./AttachOtherDocument.vue?vue&type=script&lang=js&"
export * from "./AttachOtherDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports